<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title
                    style="background-color: #009688; color: white;"
                >
                    Add coverage for: &nbsp;<v-chip>{{ data && data.ACCT_N }}</v-chip> &nbsp;{{ data && data.ACCT_M }}
                </v-card-title>
                <v-card-text>
                    <v-combobox
                        v-model.trim="newData.DIAG_T"
                        :items="getAcuDiagnosticSuggestions && Array.isArray(getAcuDiagnosticSuggestions.data) ? getAcuDiagnosticSuggestions.data.filter(aItem => !existing.some(bItem => bItem.DIAG_T.includes(aItem))) : []"
                        label="Diagnostic"
                        color="teal"
                        :rules="[v => v !== '' && v !== null && v !== undefined && /[a-zA-Z]/.test(v) || 'This field is required']"
                        clearable
                    />
                    <v-select
                        v-model.trim="newData.SCOPE"
                        label="Scope"
                        :items="scopeItem"
                        color="teal"
                        :rules="requiredField"
                    />
                    <v-text-field
                        ref="newcoverageminage"
                        v-model="newData.AGE_MN"
                        label="Min Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => v <= newData.AGE_MX || 'Must be less than or equal to Max Age'
                        ]"
                        suffix="y.o."
                        :readonly="String(newData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :disabled="String(newData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                    />
                    <v-text-field
                        ref="newcoveragemaxage"
                        v-model="newData.AGE_MX"
                        label="Max Age"
                        color="teal"
                        :rules="[
                            (v) => v !== undefined && v !== null && !isNaN(v) || 'Must be a number.',
                            (v) => Number(v) >= Number(newData.AGE_MN) || 'Must be greater than or equal to Min Age'
                        ]"
                        suffix="y.o."
                        :readonly="String(newData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :disabled="String(newData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        hint="120 represents no upper age limit."
                    />
                    <v-select
                        v-model.trim="newData.SEX"
                        label="Gender"
                        :items="sexItem"
                        item-text="label"
                        item-value="value"
                        color="teal"
                        :rules="requiredField"
                        :readonly="String(newData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :disabled="String(newData.SCOPE).trim().toUpperCase() === 'MEMBER' ? true : false"
                        :clearable="String(newData.SCOPE).trim().toUpperCase() === 'ACCOUNT' ? true : false"
                    >
                        <template #selection="{ item }">
                            <v-icon :color="item.value === 'F' ? 'pink' : item.value === 'M' ? 'blue' : ''">
                                {{ item.value === 'F' ? mdiGenderFemale : item.value === 'M' ? mdiGenderMale : '' }}
                            </v-icon> &nbsp;{{ item.label }}
                        </template>
                        <template #item="{ item }">
                            <v-icon :color="item.value === 'F' ? 'pink' : item.value === 'M' ? 'blue' : ''">
                                {{ item.value === 'F' ? mdiGenderFemale : item.value === 'M' ? mdiGenderMale : '' }}
                            </v-icon> &nbsp;{{ item.label }}
                        </template>
                    </v-select>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="teal darken-1"
                        outlined
                        @click="showDialog = false"
                    >
                        close
                    </v-btn>
                    <v-btn
                        type="submit"
                        color="teal darken-1 white--text"
                    >
                        add
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
    mdiGenderFemale,
    mdiGenderMale
} from '@mdi/js'

export default {
    props: ['show', 'data', 'existing'],
    data: ()=>({
        mdiGenderFemale,
        mdiGenderMale,
        sexItem: [
            { label: 'All', value: 'A' },
            { label: 'Male', value: 'M' },
            { label: 'Female', value: 'F' }
        ],
        scopeItem: [
            'ACCOUNT',
            'MEMBER'
        ],
        newData: {
            ACCT_N: null,
            ACCT_M: null,
            DIAG_T: null,
            AGE_MN: null,
            AGE_MX: null,
            SEX: null,
            SCOPE: null
        },
        requiredField: [v => v !== '' && v !== null && v !== undefined || 'This field is required'],
        isValidAge: [value => {
            if (value === '' || value === null) return true
            const regex = /^(0|[1-9]\d*)$/
            return regex.test(value) || 'Enter a non-negative whole number'
        }]
    }),
    computed: {
        ...mapGetters(['getAcuDiagnosticSuggestions']),
        showDialog: {
            get() {
                if (this.show) this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        'newData.SCOPE'(newVal) {
            if (newVal && String(newVal).trim().toUpperCase() === 'MEMBER') {
                this.newData.AGE_MN = 0
                this.newData.AGE_MX = 120
                this.newData.SEX = 'A'
            }
        },
        'newData.AGE_MN'() {
            this.$nextTick(() => {
                this.$refs['newcoverageminage'].validate()
                this.$refs['newcoveragemaxage'].validate()
            })
        },
        'newData.AGE_MX'() {
            this.$nextTick(() => {
                this.$refs['newcoverageminage'].validate()
                this.$refs['newcoveragemaxage'].validate()
            })
        }
    },
    methods: {
        ...mapActions(['addMsuRates', 'addAccountCoverage', 'suggestAcuDiagnostics']),
        submitForm() {
            if (this.$refs && this.$refs.form.validate()) {
                this.addAccountCoverage(this.newData).then(() => this.suggestAcuDiagnostics())
            }
        },
        initData() {
            if (this.$refs && this.$refs.form) {
                this.$refs.form.resetValidation()
            }
            this.newData = structuredClone(this.data)
        }
    }
}
</script>
